<template>
  <div class="quantity-input">
    <label
      v-if="label"
      class="quantity-input__label"
      :for="name"
    >{{ label }}:</label>

    <div :class="['quantity-input__controls', {'quantity-input__controls--small': size === 'small'}]">
      <button
        class="quantity-input__button"
        type="button"
        :disabled="modelValue <= 1"
        aria-label="Decrease Quantity"
        @click="decrease"
      >
        <span class="icon fa-minus" />
      </button>

      <input
        :id="name"
        class="quantity-input__input"
        type="number"
        :name="name"
        :value="modelValue"
        readonly
        tabindex="-1"
      >

      <button
        class="quantity-input__button"
        type="button"
        :disabled="maxValue > -1 && modelValue >= maxValue"
        aria-label="Increase Quantity"
        @click="increase"
      >
        <span class="icon fa-plus" />
      </button>
    </div>
  </div>
</template>



<script>
  export default {
    name: 'QuantityInput',

    props: {
      label: {
        type: String,
        default: ''
      },

      size: {
        type: String,
        default: null
      },

      maxValue: {
        type: Number,
        default: -1
      },

      name: {
        type: String,
        required: true
      },

      modelValue: {
        type: Number,
        required: true
      }
    },

    methods: {
      decrease() {
        const newValue = this.modelValue - 1;

        if (newValue > 0) {
          this.$emit('update:modelValue', newValue);
        }
      },

      increase() {
        const newValue = this.modelValue + 1;

        if (this.maxValue === -1 || this.maxValue >= newValue) {
          this.$emit('update:modelValue', newValue);
        }
      }
    }
  };
</script>
